import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionService } from 'src/app/core/services/action.service';
import { RouteService } from 'src/app/core/services/route.service';
import { CreateClient } from 'src/app/core/state/_actions/clients.actions';
import { Client } from 'src/app/core/state/_models/clients.models';
import { OpTypes } from 'src/app/core/state/_models/general.model';
import { getClientsOperations } from 'src/app/core/state/_selectors/clients.selector';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.scss'],
})
export class AddClientComponent implements OnInit {
  form!: UntypedFormGroup;
  clientExists = false;
  clientId = '';
  client!: Client | null;
  isProductionEnv: boolean = false;
  AddClientComponent:boolean = true;

  constructor(
    private fb: UntypedFormBuilder,
    private route: RouteService,
    private modal: NgbModal,
    private action: ActionService
  ) {}

  ngOnInit(): void {
    this.clientId = this.route.paramMap.clientId;
    this.initForm();
    this.isProductionEnv = environment.production;
  }

  close = () => {
    this.modal.dismissAll();
  };

  /**
   * Init form
   */
  initForm = () => {
    if (environment.production) {
      this.form = this.fb.group({
        Id: ['', Validators.required],
        Name: ['', [Validators.required]],
        ApplicationType: [null],
        RefreshTokenLifeTime: [null, [Validators.required, Validators.min(1)]],
        AllowedOrigin: ['', Validators.required],
        Domains: ['', Validators.required],
        Active: [false],
      });
    } else {
      this.form = this.fb.group({
        ClientId: ['', Validators.required],
        Name: ['', [Validators.required]],
        ApplicationType: [null],
        RefreshTokenLifeTime: [null, [Validators.required, Validators.min(1)]],
        AllowedOrigin: ['', Validators.required],
        Domains: ['', Validators.required],
        Active: [false],
      });
    }
  };

  /**
   * Submit Form
   */
  submit = async () => {
    try {
      let payload = {
        ...this.form.value,
      };
      await this.action.dispatch(
        OpTypes.CREATE,
        new CreateClient(payload),
        getClientsOperations
      );
      this.close();
    } catch (err) {}
  };
}
